import { Link, useLocation } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import { routes } from '@platform/core/lib/routes';
import { CollapsibleGroup } from './CollapsibleGroup';
import type { IConfigTablesGroupProps } from './IConfigTablesGroupProps';
import { menuLinkActive } from './menuLinkActive';
import { TableMenuItem } from './TableMenuItem';

/**
 * Група «Таблиці» в налаштуваннях і «Моделі даних» модуля (прототип v4 rtGroups, типово розгорнута): реалізовані таблиці — з лічильником і
 * переходом до «Усіх записів» (TableMenuItem), сутності прототипу — приглушені пункти, що відкривають «Записи й форми» з підсвіченим типом
 * (прототип goDesign → cmFocus) і активні там.
 */
export function ConfigTablesGroup({ ws, moduleKey, tables, title, openState }: IConfigTablesGroupProps) {
  const { pathname, search } = useLocation();
  if (!tables.length) return null;
  return (
    <CollapsibleGroup title={title} open={openState.isOpen('tables', true)} onToggle={() => openState.toggle('tables', true)}>
      {tables.map((x) => {
        if (x.rt) return <TableMenuItem key={x.key} ws={ws} moduleKey={moduleKey} rt={x.rt} active={false} />;
        const to = routes.moduleSettings(moduleKey, 'records', x.focus);
        const on = menuLinkActive(to, pathname, search);
        return (
          <Link key={x.key} className={cx('mnav__item', 'is-muted', on && 'is-active')} aria-current={on ? 'page' : undefined} to={to}>
            <span className="mnav__label" title={x.label}>{x.label}</span>
          </Link>
        );
      })}
    </CollapsibleGroup>
  );
}
